import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";

const LoginNovamente = () => {
  const { authUser } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (authUser) {
      navigate("/", { replace: true });
    } else {
      const timer = setTimeout(() => {
        navigate("/login", { replace: true, state: { from: "/venda-online" } });
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [authUser, navigate]);

  return (
    <div className="sessao-expirada-container min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-900 to-black relative overflow-hidden">
      {/* Efeito de fundo dinâmico */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_50%,_rgba(59,130,246,0.1)_0%,_rgba(0,0,0,0)_70%)] opacity-50 animate-pulse-slow"></div>

      <div className="relative z-10 bg-gray-800/90 backdrop-blur-md p-8 rounded-xl shadow-2xl shadow-blue-500/20 border border-blue-500/30 transform transition-all duration-500 hover:scale-105 hover:shadow-3xl">
        <h2 className="text-3xl font-bold text-red-400 mb-4 flex items-center gap-2 animate-bounce-slow">
          ⚠️ <span>Sessão expirada</span>
        </h2>
        <p className="text-gray-300 text-lg font-light leading-relaxed text-center animate-fade-in-up">
          Você foi desconectado por inatividade ou expiração do login.
          <br />
          Redirecionando para o login em <span className="text-blue-400 font-medium animate-pulse-fast">3 segundos...</span>
        </p>
      </div>
    </div>
  );
};

export default LoginNovamente;